import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { publishingDate } from "../CareersFucConfig";

const OptionSixSimilarJobs = (props: any) => {
    const { similarJobList } = props;
    const [homeUrl, setHomeUrl] = useState(window.location?.origin);
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const languageSettings = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const language = cliendConfig?.data?.data?.clientSettings?.language;
    const { t } = useTranslation();

    useEffect(() => {
        const fullUrl = window.location.href;
        if (fullUrl.includes("turbo_frontend")) {
            setHomeUrl(window.location.origin + "/turbo_frontend");
        } else if (fullUrl.includes("flk_demo")) {
            setHomeUrl(window.location.origin + "/flk_demo");
        }
    }, []);

    if (!similarJobList?.length) {return null;}

    return (
        <section className="opt6-similar-jobs">
            <h3 className="opt6-similar-title">{t("Similar Roles")}</h3>
            <div className="opt6-similar-grid">
                {similarJobList.map((job: any, idx: number) => (
                    <a
                        key={idx}
                        href={`${homeUrl}/view/${job?.id}`}
                        className="opt6-similar-card"
                    >
                        <div className="opt6-similar-card-top">
                            <span className="option6-tag">
                                {(job?.jobType?.typeName || job?.jobType || "Role").toUpperCase()}
                            </span>
                            {job?.logo && (
                                <img src={job.logo} alt="" className="opt6-similar-logo" />
                            )}
                        </div>
                        <h4 className="opt6-similar-job-title">{job?.title}</h4>
                        {job?.referenceNo && (
                            <p className="opt6-similar-ref">{job.referenceNo}</p>
                        )}
                        <div className="opt6-similar-meta">
                            {job?.location && (
                                <span>
                                    <i className="pi pi-map-marker" />
                                    {job.location}
                                </span>
                            )}
                            {job?.jobType && (
                                <span>
                                    <i className="pi pi-briefcase" />
                                    {typeof job.jobType === "string" ? job.jobType : job.jobType?.typeName}
                                </span>
                            )}
                            {job?.postedAt && (
                                <span>
                                    <i className="pi pi-calendar" />
                                    {publishingDate(job.postedAt, language)}
                                </span>
                            )}
                        </div>
                    </a>
                ))}
            </div>
        </section>
    );
};

export default OptionSixSimilarJobs;
